import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/inter";
import "@fontsource-variable/bricolage-grotesque";
import "@fontsource/instrument-serif/400-italic.css";
import "@fontsource/tiro-devanagari-hindi/devanagari-400.css";
import App from "./app/App";
import "./app/styles/tokens.css";
import "./app/styles/base.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Thekedar app root element was not found.");

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
